import Vue from "vue";
import { getUserData } from "@/auth/getUserData";

export const decrypt = (messageString: string, initializationVector: string) => {
    const decryptedMessageObject = Vue.prototype.CryptoJS.AES.decrypt(
        {
            ciphertext: Vue.prototype.CryptoJS.enc.Hex.parse(messageString),
            resetToken: "",
        },
        Vue.prototype.CryptoJS.enc.Utf8.parse(getUserData().decryptionKey),
        {
            mode: Vue.prototype.CryptoJS.mode.CTR,
            iv: Vue.prototype.CryptoJS.enc.Utf8.parse(initializationVector),
            padding: Vue.prototype.CryptoJS.pad.NoPadding,
        }
    );

    return JSON.parse(decryptedMessageObject.toString(Vue.prototype.CryptoJS.enc.Utf8));
};

export const encrypt = (payload: unknown) => {
    const iv = `${Math.random().toString(16).substr(2)}${Math.random().toString(16).substr(2)}`.substr(0, 16);

    const encryptedPayload = Vue.prototype.CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        Vue.prototype.CryptoJS.enc.Utf8.parse(getUserData().decryptionKey),
        {
            iv: Vue.prototype.CryptoJS.enc.Utf8.parse(iv),
            padding: Vue.prototype.CryptoJS.pad.NoPadding,
            mode: Vue.prototype.CryptoJS.mode.CTR,
        }
    );
    return [encryptedPayload.ciphertext.toString(), iv];
};
